export const searchPosts = queries => {
  const { searchQuery, limit = 5, pagingToken, override=false } = queries;
  return {
    type: "SEARCH_POSTS_REQUEST",
    searchQuery,
    limit,
    pagingToken,
    override,
  };
};

export const searchPostsSuccess = ({ data: posts, pagingToken, searchQuery, limit, override }) => {
  return {
    type: "SEARCH_POSTS_SUCCESS",
    posts,
    pagingToken,
    searchQuery,
    limit,
    override,
  };
};

export const searchPostsFailed = error => ({
  type: "SEARCH_POSTS_FAILED",
  error,
});

export const clearSearchPosts = () => {
  return {
    type: "CLEAR_SEARCH_POSTS",
  };
};



// WEBPACK FOOTER //
// ./src/actions/searchActions.js